/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Back_To_JobsInputs */

const en_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Jobs`)
};

const de_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Stellen`)
};

const fr_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour aux emplois`)
};

const es_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a empleos`)
};

const it_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna ai lavori`)
};

const nl_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar banen`)
};

const pl_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do ofert pracy`)
};

const fi_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin työpaikkoihin`)
};

const da_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til job`)
};

const sv_jobs_back_to_jobs = /** @type {(inputs: Jobs_Back_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till jobb`)
};

/**
* | output |
* | --- |
* | "Back to Jobs" |
*
* @param {Jobs_Back_To_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_back_to_jobs = /** @type {((inputs?: Jobs_Back_To_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Back_To_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_back_to_jobs(inputs)
	if (locale === "fr") return fr_jobs_back_to_jobs(inputs)
	if (locale === "es") return es_jobs_back_to_jobs(inputs)
	if (locale === "it") return it_jobs_back_to_jobs(inputs)
	if (locale === "nl") return nl_jobs_back_to_jobs(inputs)
	if (locale === "pl") return pl_jobs_back_to_jobs(inputs)
	if (locale === "fi") return fi_jobs_back_to_jobs(inputs)
	if (locale === "da") return da_jobs_back_to_jobs(inputs)
	if (locale === "sv") return sv_jobs_back_to_jobs(inputs)
	return en_jobs_back_to_jobs(inputs)
});